import type { DomainEvent } from '@pms/shared';

/**
 * Состояние записи в исходящей очереди.
 *
 * pending  — ждёт отправки (в том числе после неудачной попытки)
 * sending  — отправляется прямо сейчас
 * synced   — сервер подтвердил приём
 * rejected — сервер отказал по существу. Запись остаётся видимой оператору,
 *            молча ничего не удаляем.
 */
export type OutboxStatus = 'pending' | 'sending' | 'synced' | 'rejected';

export interface OutboxRecord {
  /** Совпадает с id события — он же ключ идемпотентности на сервере. */
  id: string;
  status: OutboxStatus;
  event: DomainEvent;
  createdAt: string;
  attempts: number;
  lastError?: string;
  syncedAt?: string;
  rejectedAt?: string;
  rejectionReason?: string;
}

export interface MetaRecord {
  key: string;
  value: unknown;
}

/** Ключи в таблице meta. */
export const META_DEVICE_ID = 'deviceId';
export const META_PULL_CURSOR = 'pullCursor';
export const META_LAST_PULL_AT = 'lastPullAt';
export const META_LAST_PUSH_AT = 'lastPushAt';
/** Временно, до этапа 3: кто работает на устройстве. Заменит авторизация. */
export const META_CURRENT_USER_ID = 'currentUserId';
